import PermIdentityIcon from "@mui/icons-material/PermIdentity";
import { Box, styled } from "@mui/material";
import IconButton from "@mui/material/IconButton";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import { MouseEvent, useState } from "react";
import { useAppSelector } from "../../../redux/store";
import { IWithClassName, IWithThemeProps } from "../../../theme/default.theme";

const UserAccountMenu = ({ className }: IWithClassName) => {
    const user = useAppSelector(({ auth }) => auth.user);

    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

    const handleClick = (event: MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleLogout = () => {
        window.location.href = "/logout.html";
    };

    return (
        <div className={className}>
            <Box>
                <IconButton onClick={handleClick} size="small" className="icon">
                    <PermIdentityIcon />
                </IconButton>
            </Box>
            <Menu
                anchorEl={anchorEl}
                id="user-account-menu"
                open={!!anchorEl}
                onClose={handleClose}
                onClick={handleClose}
                sx={{ ".MuiMenu-list": { margin: 0 } }}
                transformOrigin={{ horizontal: "right", vertical: "top" }}
                anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
            >
                <MenuItem onClick={handleLogout}>
                    Logout {user?.firstName}
                </MenuItem>
            </Menu>
        </div>
    );
};

export default styled(UserAccountMenu)(({ theme }: IWithThemeProps) => ({
    marginTop: theme?.spacing(4),
    padding: theme?.spacing(1, 0, 1, 0),

    ".icon": {
        marginLeft: theme?.spacing(2),
    },
}));
